import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowModelSummaryTag from './FlowModelSummaryTag';

const FlowModelSummaryTagBridge = react2angular(FlowModelSummaryTag, ['tags']);

export default FlowModelSummaryTagBridge;
